import { Button } from '@workspace/ui/components/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@workspace/ui/components/dialog';
import { Sparkles } from 'lucide-react';

interface InsufficientCreditsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onTopUp: () => void;
  title?: string;
  description?: string;
}

export function InsufficientCreditsModal({
  open,
  onOpenChange,
  onTopUp,
  title = 'AI credits exhausted',
  description,
}: InsufficientCreditsModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="gap-5 p-6 rounded-2xl sm:max-w-[520px] text-center">
        <DialogHeader className="gap-2 items-center text-center">
          <DialogTitle className="pe-0 font-bold text-gray-900 text-xl text-center leading-snug">
            {title}
          </DialogTitle>
          <DialogDescription className="mx-auto text-center text-gray-600 text-sm leading-relaxed">
            {description || (
              <>
                You&apos;ve used all your AI credits.
                <br />
                Upgrade your plan to continue using AI features without interruption.
              </>
            )}
          </DialogDescription>
        </DialogHeader>
        <div className="gap-3 grid grid-cols-2 pt-2">
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="border-gray-200 hover:bg-gray-50 rounded-xl h-11 font-medium text-gray-700 text-sm shadow-none"
          >
            Maybe later
          </Button>
          <Button
            type="button"
            onClick={onTopUp}
            className="flex justify-center items-center gap-2 bg-primary hover:bg-primary-hover rounded-xl h-11 font-medium text-sm text-white shadow-none"
          >
            <Sparkles className="size-4" />
            Upgrade plan
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

